/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getGridPageSizeState, setGridPageSizeState} from '../utils/helpers';

export interface UseGridPageSizeParams {
  name: string;
  action: Function;
  preference?: string;
};

/**
 * useGridRowsPerPage hook provide utililty functions for saving rows per page in any Grid.
 *
 * ```typescript
 *
 * import {useGridRowsPerPage} from '@ion/applications/src/hooks/';
 *
 * const [gridPageSize, setGridPageSize] = useGridRowsPerPage();
 * ```
 */
export const useGridRowsPerPage = ({name, action, preference = ''}: UseGridPageSizeParams) => {
  const dispatch                        = useDispatch();
  const pageSize                        = useSelector(({[name]: {grid}}) => grid?.pageSize);
  const [gridPageSize, setGridPageSize] = useState(getGridPageSizeState(preference) || pageSize);

  useEffect(() => {
    dispatch(action(gridPageSize));
    if (preference && gridPageSize !== pageSize) {
      setGridPageSizeState(preference, gridPageSize);
    }
  }, [gridPageSize]);

  return [
    gridPageSize,
    setGridPageSize
  ];
};

export default useGridRowsPerPage;
